(function($) {

$(document).ready(function () {

	$('#faq').find('.faq-body').eq(0).addClass('faq-open');

	$('.faq-body .question, .faq-body .faq-arrow').click(function(){
		const $item = $(this).parent();

		if(!$item.hasClass('faq-open')) {
			$('.answer').each(function(){
				if($(this).is(':visible')) $(this).slideUp('500');
				$(this).closest('.faq-body').removeClass('faq-open')
			});
			$item.find('.answer').slideDown('1000');
			$item.addClass('faq-open')
		} else {
			$item.find('.answer').slideUp('500');
			$item.removeClass('faq-open')
		}
	});

});

})(jQuery);